/**
 * Browser stand-in for @vercel/oidc.
 *
 * @vercel/blob's client imports it for server-side store auth, which pulls
 * `jose` and the OIDC exchange (~30 KB gzip) into the browser bundle. In the
 * browser an upload always carries the client token our server issues, so blob
 * resolves auth from that token and never reaches the OIDC branch; that branch
 * already treats an empty token as "none". Aliased in vite.config.ts only — the
 * server keeps the real package.
 */
export async function getVercelOidcToken(): Promise<string> {
  return "";
}
export function getVercelOidcTokenSync(): string {
  return "";
}
